import PortalIdParser from 'PortalIdParser';
export const getRootUrl = () => `/calling-cross-tab-embed/${PortalIdParser.get()}/calling-remote-app`;